'use strict';

import NewsFeed from './newsfeed/Newsfeed.service'

const state = {}

const actions = {
  ...NewsFeed.actions,
}

const mutations = {}

const getters = {}

export default { getters, actions, mutations, state }